import { createContext } from 'react';
import { EnrollmentsPageData } from '../model/enrollment';

const idleConst: "idle" | "success" | "failed" | "error" = "idle";
const defaultEnrollmentData = {
    status: idleConst,
    data: undefined, 
    error: null, 
    isFetching: false
}

export const EnrollmentsContext = createContext<EnrollmentsPageData>( defaultEnrollmentData  );